import React, { ReactElement, useEffect } from 'react'

import Checkbox from '../../../../../1stlog-ui/src/components/Checkbox'
import Field from '../../../../../1stlog-ui/src/components/Field'
import useFieldState from '../../../../../1stlog-ui/src/components/Field/useFieldState'
import useFieldValue from '../../../../../1stlog-ui/src/components/Field/useFieldValue'
import { usePrevious } from '../../../../../1stlog-ui/src/hooks'
import useOrderEntry from '../../useOrderEntry'
import { getRelevantAddressProps } from '../../utils/relevantAddressProps'

type OwnDeliveryAddressProps = {
  readonly?: boolean
}

export const OwnDeliveryAddress = (
  props: OwnDeliveryAddressProps,
): ReactElement => {
  const { readonly } = props

  const { currentCustomer } = useOrderEntry()

  const isPickup = useFieldValue('isPickup', {
    ignorePrefix: true,
  })
  const [isOwnDeliveryAddress] = useFieldState('isOwnDeliveryAddress')
  const [savedDeliveryAddress, setSavedDeliveryAddress] =
    useFieldState('savedAddress')
  const [deliveryAddress, setDeliveryAddress] = useFieldState('address')

  const previousIsOwnDeliveryAddress = usePrevious(isOwnDeliveryAddress)
  useEffect(() => {
    if (!isPickup || readonly || previousIsOwnDeliveryAddress === undefined) {
      return
    }
    if (isOwnDeliveryAddress !== previousIsOwnDeliveryAddress) {
      if (isOwnDeliveryAddress) {
        const customerAddress = currentCustomer?.customerAddress
        if (!customerAddress) {
          return
        }
        // Set customer address as delivery address
        setTimeout(() => {
          setSavedDeliveryAddress(deliveryAddress)
          global.addressPickerSkipZipCityClear++
          setDeliveryAddress(getRelevantAddressProps(customerAddress))
        }, 0)
      } else if (savedDeliveryAddress) {
        // Set saved delivery address as delivery address
        setTimeout(() => {
          global.addressPickerSkipZipCityClear++
          setDeliveryAddress(savedDeliveryAddress)
        }, 0)
      }
    }
  }, [isOwnDeliveryAddress])

  if (!isPickup || readonly) {
    return <></>
  }

  return (
    <>
      <Field name="isOwnDeliveryAddress">
        <Checkbox
          label={i18n.t(
            'use_own_address_as_delivery_address',
            'Eigene Adresse als Zustelladresse verwenden ',
          )}
        />
      </Field>
    </>
  )
}
